import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  format$default1689bsnf5arqr as format$default,
  FormatterStructure1ss012tmsg37r as FormatterStructure,
} from './Formatter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_POWERS_OF_TEN1o6pqgdjh70q1 as get_POWERS_OF_TEN } from '../../math.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnsignedIntFormatterStructureClass;
function UnsignedIntFormatterStructure() {
  if (UnsignedIntFormatterStructureClass === VOID) {
    class $ {
      constructor(number, zeroPadding) {
        this.number_1 = number;
        this.zeroPadding_1 = zeroPadding;
        // Inline function 'kotlin.require' call
        if (!(this.zeroPadding_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.zeroPadding_1 + ') is negative';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.zeroPadding_1 <= 9)) {
          var message_0 = 'The minimum number of digits (' + this.zeroPadding_1 + ') exceeds the length of an Int';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var num = this.number_1(obj);
        var numberStr = num.toString();
        // Inline function 'kotlin.repeat' call
        var times = this.zeroPadding_1 - numberStr.length | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            builder.append_58al37_k$(_Char___init__impl__6a9atx(48));
          }
           while (inductionVariable < times);
        builder.append_jgojdo_k$(numberStr);
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure()]);
    UnsignedIntFormatterStructureClass = $;
  }
  return UnsignedIntFormatterStructureClass;
}
var StringFormatterStructureClass;
function StringFormatterStructure() {
  if (StringFormatterStructureClass === VOID) {
    class $ {
      constructor(string) {
        this.string_1 = string;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        builder.append_jgojdo_k$(this.string_1(obj));
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'StringFormatterStructure', VOID, VOID, [FormatterStructure()]);
    StringFormatterStructureClass = $;
  }
  return StringFormatterStructureClass;
}
var DecimalFractionFormatterStructureClass;
function DecimalFractionFormatterStructure() {
  if (DecimalFractionFormatterStructureClass === VOID) {
    class $ {
      constructor(number, minDigits, maxDigits, zerosToAdd) {
        this.number_1 = number;
        this.minDigits_1 = minDigits;
        this.maxDigits_1 = maxDigits;
        this.zerosToAdd_1 = zerosToAdd;
        var containsArg = this.minDigits_1;
        // Inline function 'kotlin.require' call
        if (!(1 <= containsArg ? containsArg <= 9 : false)) {
          var message = 'The minimum number of digits (' + this.minDigits_1 + ') is not in range 1..9';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var containsLower = this.minDigits_1;
        var containsArg_0 = this.maxDigits_1;
        // Inline function 'kotlin.require' call
        if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
          var message_0 = 'The maximum number of digits (' + this.maxDigits_1 + ') is not in range ' + this.minDigits_1 + '..9';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var number = this.number_1(obj);
        var numberWithRequiredPrecision = number.fractionalPartWithNDigits_sivm3u_k$(this.maxDigits_1);
        var zerosToStrip = 0;
        while (this.maxDigits_1 > (this.minDigits_1 + zerosToStrip | 0) && (numberWithRequiredPrecision % get_POWERS_OF_TEN()[zerosToStrip + 1 | 0] | 0) === 0) {
          zerosToStrip = zerosToStrip + 1 | 0;
        }
        var zerosToAddBack = this.zerosToAdd_1.get_c1px32_k$((this.maxDigits_1 - zerosToStrip | 0) - 1 | 0);
        if (zerosToStrip >= zerosToAddBack)
          zerosToStrip = zerosToStrip - zerosToAddBack | 0;
        var digitsToOutput = this.maxDigits_1 - zerosToStrip | 0;
        var numberToOutput = numberWithRequiredPrecision / get_POWERS_OF_TEN()[zerosToStrip] | 0;
        builder.append_jgojdo_k$(substring((numberToOutput + get_POWERS_OF_TEN()[digitsToOutput] | 0).toString(), 1));
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'DecimalFractionFormatterStructure', VOID, VOID, [FormatterStructure()]);
    DecimalFractionFormatterStructureClass = $;
  }
  return DecimalFractionFormatterStructureClass;
}
var SignedIntFormatterStructureClass;
function SignedIntFormatterStructure() {
  if (SignedIntFormatterStructureClass === VOID) {
    class $ {
      constructor(number, zeroPadding, outputPlusOnExceededWidth) {
        this.number_1 = number;
        this.zeroPadding_1 = zeroPadding;
        this.outputPlusOnExceededWidth_1 = outputPlusOnExceededWidth;
        // Inline function 'kotlin.require' call
        if (!(this.zeroPadding_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.zeroPadding_1 + ') is negative';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.zeroPadding_1 <= 9)) {
          var message_0 = 'The minimum number of digits (' + this.zeroPadding_1 + ') exceeds the length of an Int';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var innerBuilder = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        // Inline function 'kotlin.let' call
        var it = this.number_1(obj);
        var number = minusNotRequired && it < 0 ? -it | 0 : it;
        if (!(this.outputPlusOnExceededWidth_1 == null) && number >= get_POWERS_OF_TEN()[this.outputPlusOnExceededWidth_1]) {
          innerBuilder.append_58al37_k$(_Char___init__impl__6a9atx(43));
        }
        // Inline function 'kotlin.math.absoluteValue' call
        if (abs(number) < get_POWERS_OF_TEN()[this.zeroPadding_1 - 1 | 0]) {
          if (number >= 0) {
            innerBuilder.append_uppzia_k$(number + get_POWERS_OF_TEN()[this.zeroPadding_1] | 0).deleteAt_mq1vvq_k$(0);
          } else {
            innerBuilder.append_uppzia_k$(number - get_POWERS_OF_TEN()[this.zeroPadding_1] | 0).deleteAt_mq1vvq_k$(1);
          }
        } else {
          innerBuilder.append_uppzia_k$(number);
        }
        builder.append_jgojdo_k$(innerBuilder);
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure()]);
    SignedIntFormatterStructureClass = $;
  }
  return SignedIntFormatterStructureClass;
}
var ConstantStringFormatterStructureClass;
function ConstantStringFormatterStructure() {
  if (ConstantStringFormatterStructureClass === VOID) {
    class $ {
      constructor(string) {
        this.string_1 = string;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        builder.append_jgojdo_k$(this.string_1);
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure()]);
    ConstantStringFormatterStructureClass = $;
  }
  return ConstantStringFormatterStructureClass;
}
//region block: exports
export {
  ConstantStringFormatterStructure as ConstantStringFormatterStructure25vvm6os5tq8f,
  DecimalFractionFormatterStructure as DecimalFractionFormatterStructure2fby7dmyhkzn1,
  SignedIntFormatterStructure as SignedIntFormatterStructureuogj4y4pj858,
  StringFormatterStructure as StringFormatterStructure3i97mc47fm0qc,
  UnsignedIntFormatterStructure as UnsignedIntFormatterStructure2iqfxgv3d2ejy,
};
//endregion

//# sourceMappingURL=FormatterOperation.mjs.map
